import Vue from 'vue';
import { v1 as uuid } from 'uuid';
import { Notification, NotificationType } from '@/modules/notification-center/definitions';
import { TranslateResult } from 'vue-i18n';
export * from '@/modules/notification-center/definitions';

const SUCCESS = 'success';
const INFO = 'info';
const WARN = 'warning';
const ERROR = 'error';

export const notificationCenter = Vue.observable<{ stack: Notification[] }>({ stack: [] });

function add(notification: Notification): void {
  notificationCenter.stack.push(notification);
}

function remove(notificationId: string): void {
  const notificationIndex = notificationCenter.stack.findIndex(notification => notification.id === notificationId);
  notificationCenter.stack.splice(notificationIndex, 1);
}

function pushNotification(type: NotificationType, message: TranslateResult): Notification {
  const notification: Notification = Object.freeze({ id: uuid(), type, message });
  add(notification);
  return notification;
}

export function notifySuccess(message: TranslateResult): Notification {
  return pushNotification(SUCCESS, message);
}

export function notifyInfo(message: TranslateResult): Notification {
  return pushNotification(INFO, message);
}

export function notifyWarning(message: TranslateResult): Notification {
  return pushNotification(WARN, message);
}

export function notifyError(message: TranslateResult): Notification {
  return pushNotification(ERROR, message);
}

export function closeNotification(notificationId: string): void {
  remove(notificationId);
}
